import { ROUTES } from "library/constants";
import { useLocation } from "react-router-dom";

export function useIsNeedsAttentionPage() {
  const location = useLocation();
  const isNeedsAttentionPage = ROUTES.NEEDS_ATTENTION === location.pathname;

  return isNeedsAttentionPage;
}
